const initialState = { credentials: null, currentCredential: null };

const courseReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CREATE_CREDENTIAL": {
      return {
        ...state,
        currentCredential: null
      };
    }
    case "FETCH_CREDENTIAL": {
      return {
        ...state,
        currentCredential: action.data,
      };
    }
    default:
      return state;
  }
};

export default courseReducer;
